<template>
  <base-input
    v-noSpecialCharacters
    :label="$t('WithdrawToCard | inputCardNumberLabel')"
    maxlength="19"
    :error-message="
      !isValid ? `${$t('WithdrawToCard | incorrectCardNumber')}` : null
    "
    :model-value="formattedCardNumber"
    @update:modelValue="updateCardNumber"
  />
</template>

<script>
import BaseInput from '@emcd-shared/base-input'
import { formatCardNumber } from '@/shared/lib/formatCardNumber'
import noSpecialCharacters from '@/shared/lib/directives/noSpecialCharacters'

export default {
  components: {
    BaseInput,
  },

  props: {
    value: {
      required: true,
    },
  },

  emits: ['input'],

  directives: {
    noSpecialCharacters,
  },

  computed: {
    formattedCardNumber() {
      return formatCardNumber(this.value)
    },

    // Check that card number is valid
    isValid() {
      // Empty field is valid
      if (this.value === null || this.value === '') return true

      // Check the length
      return this.value.length === 16
    },
  },

  methods: {
    updateCardNumber(e) {
      const cardNumber = e.replace(/ /g, '')
      // const cardNumber = e.target.value.replace(/ /g, "");
      this.$emit('input', cardNumber)
    },
  },
}
</script>
